// extracted by mini-css-extract-plugin
export default {"linksGroupWrapper":"styles_linksGroupWrapper__FDgcZ"};